const moduleName = 'table';

export function table() {
    //let currentCountPerRow = 0;
    const tableInit = (table) => {
        const max480 = window.matchMedia('(max-width: 480px)');
        const items = Array.from(table.querySelectorAll('.js-cell'));
        const emptyItems = Array.from(table.querySelectorAll('.js-empty-cell'));
        const length = items.length;
        const emptyLength = emptyItems.length;
        let countPerRow;
        if(max480.matches) {
            countPerRow = 3;
        }else {
            countPerRow = 5;
        }

        const limit = countPerRow - (length % countPerRow);
        if(emptyLength > limit) {
            for (let i = 0; i < limit + 1;i++) {
                emptyItems[i].remove();
            }
        }else {
            if(length % countPerRow){
                for (let i = 0; i < limit;i++) {
                    table.insertAdjacentHTML('beforeend', '<div class="brands__item brands__item--empty js-cell js-empty-cell"></div>');
                }
            }
        }


    }
    const tables = Array.from(document.body.querySelectorAll('.js-table'));
    if(tables.length) {
        tables.forEach((table) => {
            tableInit(table);
        });
        window.addEventListener('resize', function () {
            tables.forEach((table) => {
                tableInit(table);
            });
        });
    }
}
